export const QUOTE_HEADER_ROOT = 'js-quote-header-prices'
export const STATIC_PRICE_SELECTOR = '.js-is-static-price'
